export default __webpack_public_path__ + "static/Map-Bandung-0cca9a2692ad57f7b89ec1c858e6a98d.png";